import { KuxFilteredCategoriesDTO } from '../compat/tvpil';
import type { RhinoImageRatio } from '../image';

import { ImageSize } from './useImageSettings';
import { useRailSettings } from './useRailSettings';

type UseRentalsSettingsProps = {
  defaultImageRatio?: RhinoImageRatio;
  defaultLandscapeImageHeight?: number;
  defaultPortraitImageHeight?: number;
  imageSize?: ImageSize;
  referenceId: string;
};

export type RentalsSettings = {
  branding: KuxFilteredCategoriesDTO['uiDesignElements'];
  id: number;
  imageHeight: number | undefined;
  imageType: number | undefined;
  imageWidth: number | undefined;
  shouldShowRating: boolean;
  title: string;
};

export function useRentalsSettings(props: UseRentalsSettingsProps) {
  const settings = useRailSettings(props);

  if (!settings) {
    return undefined;
  }

  const { branding, id, imageHeight, imageWidth, imageType, shouldShowRating, title } = settings;

  return {
    branding,
    id,
    imageHeight,
    imageType,
    imageWidth,
    shouldShowRating,
    title,
  };
}
